import {AbstractAPIService} from '@shared/interfaces/service-classes';
import {Observable} from 'rxjs';
import {FormulaVariableDefinition} from "@shared/components/formula-builder/formula-builder.component";
import {FormulaDinamicaModel, FormulaDinamicaTestRequest} from "@shared/models/formula-dinamica";
import {environment} from "@env/environment";
import {Injectable} from "@angular/core";

@Injectable()
export class CamposDinamicosFormulaService extends AbstractAPIService {

  buildUrlBase(args?: any): string {
    return `${environment.api.cuenta.formulaCamposDinamicos}`;
  }

  getSysVariables() : Observable<FormulaVariableDefinition[]> {
    return this.http.get<FormulaVariableDefinition[]>(this.buildUrlBase() + '/system-variables');
  }

  checkSyntax(formula: FormulaDinamicaModel) : Observable<boolean> {
    return this.http.post<boolean>(this.buildUrlBase() + '/syntax', formula);
  }

  test(request: FormulaDinamicaTestRequest, cuentaId: number) : Observable<boolean> {
    return this.http.post<boolean>(this.buildUrlBase(cuentaId) + '/test-case', request);
  }

  downloadDetalle(request: FormulaDinamicaTestRequest, cuentaId: number) : Observable<Blob> {
    return this.http.post(this.buildUrlBase(cuentaId) + '/test-case/xlsx', request, {responseType: 'blob'});
  }

}
